import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import { toast } from "sonner";

import TagMeetingHeader from "../components/TagMeetingHeader";
import { forgotSchema } from "../utils/validation";
import serviceEndpoints from "../services/serviceEndpoints";
import { axiosInstance } from "../service/axiosInstance";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const { values, handleChange, handleSubmit, errors, touched, resetForm } =
    useFormik({
      initialValues: { email: "", otp: "", password: "" },
      onSubmit: (values) => handleForgotPassword(values),
      validationSchema: forgotSchema,
    });

  async function handleForgotPassword(value) {
    setLoading(true);
    try {
      let res = await axiosInstance.post(
        serviceEndpoints.forgotPasswordEndpoints,
        {
          email: value.email,
        }
      );
      toast.success(res?.data?.message);
      resetForm();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  return (
    <>
      <TagMeetingHeader headerName="Forgot Password" />
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <Box
          sx={{
            width: "100%",
            maxWidth: 360,
          }}
        >
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              id="email"
              name="email"
              label="Email"
              variant="outlined"
              error={touched.email && errors.email}
              helperText={touched.email && errors.email}
              value={values.email}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />

            <Typography
              variant="body2"
              sx={{ color: "#030303ff;", textAlign: "right" }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                Login?
              </Link>
            </Typography>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                borderRadius: "25px",
                textTransform: "none",
                fontSize: "16px",
                mt: 2,
              }}
              disabled={loading}
            >
              Submit
            </Button>
          </form>
        </Box>
      </div>
    </>
  );
};

export default ForgotPassword;
